import { useUserConfig } from '../userConfig/useUserConfig';

export function useTheme() {
  const { theme, setTheme } = useUserConfig();
  return { theme, setTheme };
}
